import { RadioInput } from 'lib/components';
import { Flex, Gap } from 'lib/components/styles/layout';
import {
  ParagraphExtraSmall,
  ParagraphSmall,
  ParagraphSmallBold,
} from 'lib/components/styles/typography';
import React from 'react';
import { Tag } from 'react-covideo-common';
import { SiSimpleanalytics } from 'react-icons/si';
import styled, { useTheme } from 'styled-components/macro';
import { VideoThumbnail, VideoThumbnailSource } from './style';
import { toMMSS } from 'lib/utils/functions';
import { IVideoDetails } from 'lib/api/quickVideo/types';

const VideoDuration = styled.div`
  border-radius: 4px;
  display: inline-flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  background-color: ${props => props.theme.colors.neutral[80]};
  color: ${props => props.theme.colors.white[100]};

  font-size: 10px;

  position: absolute;
  bottom: 2px;
  right: 2px;
`;

const GapWithScroll = styled(Gap)`
  overflow-x: auto;
  padding-bottom: 4px;

  &::-webkit-scrollbar {
    height: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.colors.neutral[60]};
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.colors.neutral[10]};
  }
`;

type ModalVideoItemProps = {
  setSelectedVideo?: (video: IVideoDetails) => void;
  selectedVideo?: IVideoDetails | null;
  video: IVideoDetails;
};

export const VideoItem = ({
  setSelectedVideo,
  selectedVideo,
  video,
}: ModalVideoItemProps) => {
  const theme = useTheme();
  const videoTags = video.tags || [];

  return (
    <Gap gap='12px' width='675px'>
      {!!setSelectedVideo && (
        <RadioInput
          onChange={() => {
            setSelectedVideo(video);
          }}
          onClick={() => {
            setSelectedVideo(video);
          }}
          name=''
          value={video.id}
          checked={video.id === selectedVideo?.id}
        />
      )}

      <Gap alignItems='flex-start'>
        <VideoThumbnail>
          <VideoThumbnailSource src={video.thumbnail} alt={video.title} />
          <VideoDuration>
            {video.videoLength
              ? toMMSS(video.videoLength / 1000).split('.')[0]
              : '...'}
          </VideoDuration>
        </VideoThumbnail>

        <Flex flexWrap='nowrap' width='fit-content'>
          <ParagraphSmallBold>{video.title}</ParagraphSmallBold>
          <Gap flexDirection='row' gap='8px' m='2px 0 0 0'>
            <ParagraphExtraSmall>{video.recordDate}</ParagraphExtraSmall>
            <ParagraphExtraSmall color={theme.colors.neutral[60]}>
              •
            </ParagraphExtraSmall>
            <ParagraphExtraSmall>{`${video.user?.firstName} ${video.user?.lastName}`}</ParagraphExtraSmall>
          </Gap>

          <Gap
            flexDirection='row'
            gap='8px'
            alignItems='flex-start'
            m='4px 0 0 0'
          >
            <Gap gap='4px'>
              <SiSimpleanalytics size={12} color={theme.colors.neutral[40]} />
              <ParagraphSmall>{`${video.views} view${Number(video.views) === 1 ? '' : 's'}`}</ParagraphSmall>
            </Gap>

            <GapWithScroll width='450px' flexWrap='nowrap'>
              {videoTags.map(tag => (
                <Tag
                  key={`tag-${tag.tagId}`}
                  extendStyles={{
                    text: {
                      whiteSpace: 'nowrap',
                    },
                  }}
                  tag={{
                    value: tag.tagId,
                    label: tag.tag,
                  }}
                />
              ))}
            </GapWithScroll>
          </Gap>
        </Flex>
      </Gap>
    </Gap>
  );
};
